var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-labelled', {
    attrs: {
      "label": _vm.label,
      "id": _vm.realId,
      "error": _vm.error,
      "action": _vm.labelAction,
      "label-hidden": _vm.labelHidden,
      "help-text": _vm.helpText
    }
  }, [(_vm.$slots.helpText) ? _c('template', {
    slot: "helpText"
  }, [_vm._t("helpText")], 2) : _vm._e(), _vm._v(" "), _c('polaris-connected', [_c('template', {
    slot: "left"
  }, [_vm._t("connectedLeft", [_vm._v(_vm._s(_vm.connectedLeft))])], 2), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_vm._t("connectedRight", [_vm._v(_vm._s(_vm.connectedRight))])], 2), _vm._v(" "), _c('div', {
    class: _vm.classes,
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "click": _vm.onClick
    }
  }, [(_vm.prefix) ? _c('div', {
    staticClass: "Polaris-TextField__Prefix",
    attrs: {
      "id": _vm.realId + 'Prefix'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.prefix) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('dynamic-tag', {
    ref: "input",
    staticClass: "Polaris-TextField__Input",
    style: ({
      height: (_vm.multiline && _vm.height) ? _vm.height + 'px' : null
    }),
    attrs: {
      "tag": _vm.multiline ? 'textarea' : 'input',
      "name": _vm.name,
      "id": _vm.realId,
      "type": _vm.type,
      "disabled": _vm.disabled,
      "readonly": _vm.readOnly,
      "autofocus": _vm.autoFocus,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "on": {
        change: _vm.handleChange
      },
      "autocomplete": _vm.autoComplete,
      "aria-describedby": _vm.describedBy,
      "aria-labelledby": _vm.labelledBy,
      "aria-invalid": Boolean(_vm.error)
    }
  }), _vm._v(" "), (_vm.suffix) ? _c('div', {
    staticClass: "Polaris-TextField__Suffix",
    attrs: {
      "id": _vm.realId + 'Suffix'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.suffix) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type === 'number' && !_vm.disabled) ? _c('polaris-text-field-spinner', {
    on: {
      "change": _vm.handleNumberChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-TextField__Backdrop"
  }), _vm._v(" "), (_vm.multiline) ? _c('polaris-text-field-resizer', {
    attrs: {
      "contents": _vm.value || _vm.placeholder,
      "current-height": _vm.height,
      "minimum-lines": (typeof _vm.multiline === 'number') ? _vm.multiline : 1
    },
    on: {
      "heightchange": _vm.handleExpandingResize
    }
  }) : _vm._e()], 1)], 2)], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-172bef7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172bef7e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisTextField.vue
// module id = 313
// module chunks = 0